export const clientId = 'chefslife-96b51ce9a773c8372735b7559a92ae7a4398614513188052515';
export const clientSecret = '6n6JmMTmTL0JEg7H6tXHtJoliMmBAIZvfGQjuu47';
export const redirectUrl = 'http://localhost:3001/callback';